import axios from 'axios';

//apply base url for axios
const API_URL = ''; //"https://jsonplaceholder.typicode.com";

export const axiosApi = axios.create({
  baseURL: API_URL
});

axiosApi.defaults.headers.common['Authorization'] = '';

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then((response) => response.data);
}

export async function post(url, data = {}, config = {}) {
  return axiosApi.post(url, { ...data }, { ...config }).then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((error) => error.response.data.message);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url, { ...config }).then((response) => response.data);
}
